import {ClientHttp} from './client.http';
import {NgModule, Provider} from '@angular/core';
import {BrowserXhr, Http, HttpModule, RequestOptions, ResponseOptions, XHRBackend, XSRFStrategy} from '@angular/http';
import {ClientXhrBackend} from "./client.xhr.backend";

const HTTP_CLIENT_PROVIDER: Provider = {
    provide: Http,
    useFactory: (backend: XHRBackend, options: RequestOptions) => new ClientHttp(backend, options),
    deps: [XHRBackend, RequestOptions]
};

const CLIENT_XHR_BACKEND_PROVIDER = {
    provide: XHRBackend,
    useFactory: (browser: BrowserXhr, options: ResponseOptions, strategy: XSRFStrategy) => {
        return new ClientXhrBackend(browser, options, strategy);
    },
    deps: [BrowserXhr, ResponseOptions, XSRFStrategy]
};

@NgModule({
    imports: [
        HttpModule
    ],

    providers: [
        CLIENT_XHR_BACKEND_PROVIDER,
        HTTP_CLIENT_PROVIDER
    ],

    exports: [
        HttpModule
    ]
})
export class ClientHttpModule {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/client.http.module.ts